import { render, staticRenderFns } from "./permissao.vue?vue&type=template&id=d02892b0&"
import script from "./permissao.vue?vue&type=script&lang=js&"
export * from "./permissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports